



































import Vue from 'vue';
import VueSelect from 'vue-select';

export default Vue.extend({
  inheritAttrs: false,
  name: 'VueSelectWrapper',
  components: {
    VueSelect,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
});
